// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json = require("../Json.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Js_mapperRt = require("bs-platform/lib/js/js_mapperRt.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");

var jsMapperConstantArray = [
  200,
  201,
  202,
  203,
  204,
  205,
  206,
  207,
  208,
  226,
  300,
  301,
  302,
  303,
  304,
  305,
  306,
  307,
  308,
  400,
  401,
  402,
  403,
  404,
  405,
  406,
  407,
  408,
  409,
  410,
  411,
  412,
  413,
  414,
  415,
  416,
  417,
  418,
  421,
  422,
  423,
  424,
  426,
  428,
  429,
  431,
  451,
  500,
  501,
  502,
  503,
  504,
  505,
  506,
  507,
  508,
  510,
  511
];

function tToJs(param) {
  return jsMapperConstantArray[param];
}

function tFromJs(param) {
  return Js_mapperRt.fromInt(58, jsMapperConstantArray, param);
}

var decode = Curry._1(Json.Decode.variantFromInt, tFromJs);

function encode(param) {
  return Relude_Globals.$great$great(tToJs, (function (prim) {
                return prim;
              }), param);
}

exports.tToJs = tToJs;
exports.tFromJs = tFromJs;
exports.decode = decode;
exports.encode = encode;
/* decode Not a pure module */
